import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import { useForm } from "antd/lib/form/Form";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetDataOnScroll } from "../../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import i18n from "i18next";
import _ from "lodash";
import { EmptyData } from "../../../../components/empty/emptyData";
import { PageHeader } from "../../../../components/page-header";
import { ContentPartFilter } from "../../../../components/content-part/ContentPartFilter";
import { useTradeRegistry } from "./useTradeRegistry";
import { useLazyGetTradeRegistryListAllQuery } from "../../../../redux/api/organic/tradeRegistryApi";
import { EntTradeRegistry } from "../../../../models/organic/tradeRegistry";
import { EntTradeRegistryFilter } from "../../../../models/filters/organic/tradeRegistryFilter";
import { FilterTradeRegistry } from "./FilterTradeRegistry";
import { AddTradeRegistryModal } from "./AddTradeRegistry";


enum FormField {
  year,
  month,
  tradeType,
  citizenshipId,
  productTypeId,
  regionOfDispatchId,
  regionOfArrivalId
}

const months = [
  { value: 1, label: "Январь" },
  { value: 2, label: "Февраль" },
  { value: 3, label: "Март" },
  { value: 4, label: "Апрель" },
  { value: 5, label: "Май" },
  { value: 6, label: "Июнь" },
  { value: 7, label: "Июль" },
  { value: 8, label: "Август" },
  { value: 9, label: "Сентябрь" },
  { value: 10, label: "Октябрь" },
  { value: 11, label: "Ноябрь" },
  { value: 12, label: "Декабрь" },
];

const operationOptions = [
  { label: "Импорт", value: "IMPORT" },
  { label: "Экспорт", value: "EXPORT" },
];

export const TradeRegistry = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [selectedItem, setSelectedItem] = useState<EntTradeRegistry>(new EntTradeRegistry());
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showReportModal, setShowReportModal] = useState<boolean>(false);
  const [form] = useForm();
  const { t } = useTranslation()

  const [getArchiveFolders] = useLazyGetTradeRegistryListAllQuery();
  const {
	filter,
	fetching,
	data,
	access,
	totalItems,
	setData,
	setFetching,
	setFilter,
	scrollHandler,
	setCurrentPage
  } = useGetDataOnScroll<EntTradeRegistry, EntTradeRegistryFilter>({
	initialFilter: new EntTradeRegistryFilter(),
	query: getArchiveFolders
  });

  const { onAddTradeRegistry, onDeleteTradeRegistry, onEditTradeRegistry } = useTradeRegistry(modal, () => {
	searchHandleClick();
  })
  const [height, setHeight] = useState<number>(0);

  const storedData = JSON.parse(localStorage.getItem("availableRoutes") || "[]");
  const isReportAvailable = storedData.some((route: any) => (route.alias === "/report" || route.alias === "/interactive-map-ws") && route.methodPost);

  const openAddModal = (item: EntTradeRegistry) => {
	setSelectedItem(item);
	setShowModal(true);
  }

  const setEntityFromFields = (): EntTradeRegistryFilter => {
	let filt: EntTradeRegistryFilter = _.clone(filter);
	filt.year = form.getFieldValue(FormField.year) ?? null;
	filt.month = form.getFieldValue(FormField.month) ?? null;
	filt.tradeType = form.getFieldValue(FormField.tradeType) ?? null;
	filt.citizenshipId = form.getFieldValue(FormField.citizenshipId) ?? null;
	filt.productTypeId = form.getFieldValue(FormField.productTypeId) ?? null;
	filt.regionOfDispatchId = form.getFieldValue(FormField.regionOfDispatchId) ?? null;
	filt.regionOfArrivalId = form.getFieldValue(FormField.regionOfArrivalId) ?? null;
	filt.page = 1;
	return filt;
  }

  const clearFields = () => {
	form.setFields([
	  { name: FormField.year, value: null },
	  { name: FormField.month, value: null },
	  { name: FormField.tradeType, value: null },
	  { name: FormField.citizenshipId, value: null },
	  { name: FormField.productTypeId, value: null },
	  { name: FormField.regionOfDispatchId, value: null },
	  { name: FormField.regionOfArrivalId, value: null },
	]);
  }

  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }

  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto' } } onScroll={ scrollHandler }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th>{ t('Год') } </th>
		  <th>{ t('Месяц') }</th>
		  <th>{ t('Тип торговли') }</th>
		  <th>{ t('Область') }</th>
		  <th>{ t('Вид продукта') }</th>
		  <th>{ t('Единица измерения') }</th>
		  <th>{ t('Количество') }</th>
		  <th>{ t('Стоимость') }</th>
		  <th>{ t('Регион отгрузки') }</th>
		  <th>{ t('Регион прибытия') }</th>
		  <th style={ { width: "120px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ? (
		  <tr>
			<th colSpan={ 7 }>
			  <Spin spinning={ fetching } style={ {
				width: '100%',
				height: '180px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			  } }/>
			</th>
		  </tr>
		) : null }
		{ data.length !== 0 ? data.map((item, index) => (
		  <tr key={ item.id }>
			<td>{ ++index }</td>
			<td>{ item.year }</td>
			<td>
			  { months.find((m) => m.value === item.month)?.label || "-" }
			</td>
			<td>
			  { operationOptions.find((o) => o.value === item.tradeType)?.label || "-" }
			</td>
			<td>{ i18n.language === 'ru' ? item.citizenship?.countryRu : item.citizenship?.countryKy }</td>
			<td>{ i18n.language === 'ru' ? item.productType?.nameRu : item.productType?.nameKy }</td>
			<td>{ i18n.language === 'ru' ? item.unitOfMeasurement?.nameRu : item.unitOfMeasurement?.nameKy }</td>
			<td>{ item.quantity }</td>
			<td>{ item.value }</td>
			<td>{ i18n.language === 'ru' ? item.regionOfDispatch?.nameRu : item.regionOfDispatch?.nameKy }</td>
			<td>{ i18n.language === 'ru' ? item.regionOfArrival?.nameRu : item.regionOfArrival?.nameKy }</td>
			<td>
			  <Flex gap="small">
				{ access && access.methodPut && (
				  <Tooltip title={ t('general.edit') }>
					<Button className='btn_edit' onClick={ () => {
					  openAddModal(item)
					} } type="primary" shape="circle" icon={ <EditOutlined/> }/>
				  </Tooltip>
				) }
				{ access && access.methodDelete && (
				  <Tooltip title={ t('general.delete') }>
					<Button className='btn_edit' danger onClick={ () => {
					  onDeleteTradeRegistry(item)
					} } type="primary" shape="circle" icon={ <DeleteOutlined/> }/>
				  </Tooltip>
				) }
			  </Flex>
			</td>
		  </tr>
		)) : (
		  <tr>
			<td colSpan={ 9 }>
			  <EmptyData/>
			</td>
		  </tr>
		) }
		</tbody>
	  </table>
	</div>
  );

  return (
	<>
	  <PageHeader
		title={ t('Экспорт/импорт') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } } type="secondary">
			{ t('general.records_found') } { totalItems }
		  </Typography.Text>
		}
	  />
	  { access && access.methodPost && (
		<Button type="primary" icon={ <PlusOutlined/> } onClick={ () => {
		  openAddModal(new EntTradeRegistry())
		} }>
		  { t('general.add') }
		</Button>
	  ) }
	  <ContentPartFilter
		filter={ <FilterTradeRegistry
		  onSearch={ searchHandleClick }
		  onReset={ () => {
			clearFields();
			searchHandleClick()
		  } }
		  formField={ FormField }
		  form={ form }
		/> }
		setHeight={ setHeight }
		table={ table }
	  />

	  <AddTradeRegistryModal
		item={ selectedItem }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		} }
		onSubmit={ selectedItem.id !== null ? onEditTradeRegistry : onAddTradeRegistry }
	  />
	  { contextHolder }
	</>
  );
}
